module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hcxQ0Y/tc-custom/9781609948313.jpg?1701235679562",
      "alt": "This image is the cover for the book How to Change Minds"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Change Minds\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Persuade, Don’t Push!    Surely you know plenty of people who need to make a change, but despite your most well-intentioned efforts, they resist because people fundamentally fear change. As a salesman, father, friend, and consultant, Rob Jolles knows this scenario all too well. Drawing on his highly successful sales background and decades of research, he lays out a simple, repeatable, predictable, and ethical process that will enable you to lead others to discover for themselves what and why they need to change. Whether you hope to make a sale or improve a relationship, Jolles’s wise advice—illustrated through a bevy of sometimes funny, sometimes moving, always illuminating stories—will help you ensure that changing someone’s mind is never an act of coercion but rather one of caring and compassion.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rob Jolles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rob Jolles is president of Jolles Associates, Inc., an international training consulting corporation, was a record-setting salesperson and sales trainer for New York Life and Xerox, and draws on more than thirty years of experience changing people’s minds. He is the author of four previous books, including Customer Centered Selling.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Berrett-Koehler Publishers, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0